import fetch from '../api/fetch';
import config from '../config';
import AsyncStorage from '@react-native-async-storage/async-storage';
import WizzeeLog from './wizzeeLog';

const getConfiguration = (): Promise<any> => {
    return fetch(config.STATIC_CONFIG_URL, {
        method: 'GET',
        headers: {
            'Cache-Control': 'no-cache',
        },
    })
    .then(response => response.json())
    .then(staticConfig => {
        WizzeeLog.log('>>> [OK] static configuration downloaded (%d bytes)', JSON.stringify(staticConfig).length);
        return Promise.resolve(staticConfig);
    });
};

export const saveTaxExemptionByArea = (): Promise<any> => {
    return getConfiguration()
    .then(staticConfig => {
        AsyncStorage.setItem('TAX_EXEMPTIONS_BY_AREA', JSON.stringify(staticConfig.taxExemptionByArea))
        .then(() => WizzeeLog.log('>>> [SAVED] taxExemptionByArea'))
        .catch(e =>
            WizzeeLog.error('>>> Could not save tax exemption by area in local storage', e),
        );

        return Promise.resolve(staticConfig.taxExemptionByArea);
    });
};

export const loadTaxExemptionByArea = (): Promise<any> => {
    return AsyncStorage.getItem('TAX_EXEMPTIONS_BY_AREA')
    .then(data => {
        if (data) {
            WizzeeLog.log('Loading taxExemptionByArea from local storage');
            return JSON.parse(data);
        } else {
            WizzeeLog.log('No taxExemptionByArea in local storage');
            return Promise.resolve(null);
        }
    });
};